import { AxiosResponse } from "axios";
import { getRequest, postRequest } from "services/client/request";
import { Business } from "types/Dashboard";

const apiVersion = "/api/v1";

export const getAllSettings = async (accessToken: string): Promise<any[]> => {
  // const response: AxiosResponse<AxiosGenericResponse<Variables[]>> =
  //   await getRequest(`${apiVersion}/settings`, accessToken);
  const variables: any[] = [
    {
      id: 1,
      name: "Stamp Description",
      value: "Free Coffee",
      created_at: "2022-01-27T19:28:10.000000Z"
    },
    {
      id: 1,
      name: "Business Description",
      value: "Coffee made with heart",
      created_at: "2022-01-27T19:28:10.000000Z"
    },
    {
      id: 1,
      name: "Opening Hours",
      value: "7am - 3pm",
      created_at: "2022-01-27T19:28:10.000000Z"
    },
    {
      id: 1,
      name: "Terms and Condition",
      value: "Ony valid for reguar size coffee",
      created_at: "2022-01-27T19:28:10.000000Z"
    }
  ];
  return variables;
};

export const createSettingVariables = async (
  request: any,
  accessToken: string
): Promise<void> => {
  await postRequest(`${apiVersion}/settings`, accessToken, request);
};

export const getBusinessCardApi = async (
  accessToken: string,
  businessId: string
): Promise<Business> => {
  const response: AxiosResponse<Business> = await getRequest(
    `${apiVersion}/business/update/${businessId}`,
    accessToken
  );

  return response.data;
};
